<template>
  <div>
    <p class="text-zt-xl font-bold mb-8">
      {{ $t(`message.publishDocuments.${processType}.title`) }}
    </p>
    <div class="mb-6">
      <p class="text-zt-lg font-medium mb-6">
        {{ $t(`message.publishDocuments.${processType}.subtitle`) }}
      </p>
      <p
        class="text-zt-base w-11/12 text-zt-dark-300"
        v-html="$sanitize($t(`message.publishDocuments.${processType}.description`))"
      ></p>
    </div>
    <div class="items-center mt-16 mb-8">
      <div class="inline-block w-11/12 relative h-32">
        <template v-if="loading">
          <div class="h-32 absolute inset-0 bg-white z-20 -mt-4">
            <div class="border border-1 border-zt-dark-200 h-24">
              <div
                class="w-full text-center text-format flex justify-center items-center"
                style="height: 90%"
              >
                <zt-icon name="box-arrow-top" class="text-4xl pr-4" />
                <div>
                  <p class="text-lg">
                    {{
                      $t(
                        `message.publishDocuments.${processType}.uploadingFile`
                      )
                    }}
                  </p>
                  <p class="text-sm font-bold">{{ fileName }}</p>
                </div>
              </div>
              <div class="w-full" style="height: 10%">
                <div class="progress-line"></div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="!loading && success">
          <div class="h-32 absolute inset-0 bg-white z-20 -mt-4">
            <div class="border border-1 border-zt-dark-200 h-24">
              <div
                class="w-full text-center text-format flex justify-center items-center"
                style="height: 90%"
              >
                <zt-icon name="clock" class="text-zt-xl mr-3" />
                <span
                  v-html="
                  $sanitize($t(`message.publishDocuments.${processType}.proccessWait`, {
                      link: processesLink,
                    }))
                  "
                  class="text-zt-base"
                  ></span
                >
              </div>
              <div class="w-full" style="height: 10%">
                <div class="progress-line"></div>
              </div>
            </div>
          </div>
        </template>
        <template>
          <zt-input-file
            @change="upload"
            outlined
            :label="$t(`message.publishDocuments.${processType}.label`)"
            prepend-outer-icon="paperclip-2"
            filetypes=".pdf"
            :redIfError="error"
          >
            <template slot="message">
              <span v-if="error" class="text-zt-danger text-zt-base">{{
                error
              }}</span>
            </template>
          </zt-input-file>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import PublishDocuments from "@/apiClient/PublishDocuments";

export default {
  inject: ["state", "mutations"],
  props: {
    processType: {
      type: String,
      default: "",
    },
    goToSchedulerList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      publishDocuments: new PublishDocuments(),
      loading: false,
      success: false,
      file: "",
      error: "",
      fileName: "",
    };
  },
  computed: {
    processesLink() {
      return location.origin + "/s/company/process-manager";
    },
  },
  methods: {
    async upload(file) {
      this.$emit('updateLoading', true);
      this.fileName = file.name;
      this.loading = true;
      this.file = file;
      if (this.file.size > 7500000000) {
        this.error = this.$t(
          "message.publishDocuments.onlyPublish.fileSizeExceded"
        );
        this.loading = false;
        this.$emit('updateLoading', false);
        return;
      }
      if (this.file.type !== "application/pdf") {
        this.error = this.$t(
          `message.publishDocuments.${this.processType}.wrongFiletype`
        );
        this.loading = false;
        this.$emit('updateLoading', false);
        return;
      }

      let params = {
        file: this.file,
        documentType: this.state.documentType.id,
        period: this.state.period,
        sendMail: this.state.sendNotification,
        type: this.processType
      };
      if (this.state.companyEmail) {
        params = { ...params, companyEmail: this.state.companyEmail };
      }

      await this.publishDocuments
        .uploadFileToSplit(params)
        .then((response) => {
          //Set response data to Observer
          this.loading = false;
          this.success = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = this.$t(
            `message.publishDocuments.errors.${error.response.data.codes[0].code}`
          );
        });
    },
  },
  watch: {
    async file(val) {
      if (!val) {
        this.error = "";
        if (this.state.idCarga) {
          await this.publishDocuments
            .deleteFile(this.state.idCarga)
            .then((res) => {
              this.file = "";
              this.mutations.setIdCarga("");
              this.mutations.setUploadedFileData({});
            });
        }
      }
    },
  },
  created() {
    if (this.goToSchedulerList) {
      this.loading = false
      this.success = true
    }
  }
};
</script>

<style lang="scss" scoped>
.text-format {
  font-family: Roboto;
  color: #707070;
}
//Progress bar
.progress-line,
.progress-line:before {
  height: 100%;
  width: 100%;
  margin: 0;
}
.progress-line {
  background-color: #cac6e3;
  display: -webkit-flex;
  display: flex;
}
.progress-line:before {
  background-color: #4f41a3;
  content: "";
  -webkit-animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@-webkit-keyframes running-progress {
  0% {
    margin-left: 0px;
    margin-right: 100%;
  }
  50% {
    margin-left: 25%;
    margin-right: 0%;
  }
  100% {
    margin-left: 100%;
    margin-right: 0;
  }
}
@keyframes running-progress {
  0% {
    margin-left: 0px;
    margin-right: 100%;
  }
  50% {
    margin-left: 25%;
    margin-right: 0%;
  }
  100% {
    margin-left: 100%;
    margin-right: 0;
  }
}
//Fake input
.zt-input-main {
  font-size: 1rem;
}
</style>
